// extracted by mini-css-extract-plugin
export default {"wixFee":"_1JxE3"};